import { Label } from "layout/typography/Label";
import { Chips } from "primereact/chips";
import { useState, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Title = styled.h3`
  margin-bottom: 16px;
`;

export function Aliases() {
  const { control, watch } = useFormContext();
  const [aliases, setAliases] = useState<string[]>([]);
  const watchedAliases = watch("aliases");

  useEffect(() => {
    if (watchedAliases) {
      setAliases(watchedAliases);
    }
  }, [watchedAliases]);

  return (
    <div className="block bg-white border-round p-4 mb-4">
      <Title>Aliases</Title>
      <Label htmlFor="aliases">Add Aliases</Label>
      <Controller
        name="aliases"
        control={control}
        render={({ field: { onChange } }) => (
          <Chips
            id="aliases"
            value={aliases}
            className="w-full mt-2"
            onChange={(e: any) => {
              setAliases(e.value.map((item: any) => item.trim()));
              onChange(e.value.map((item: any) => item.trim()));
            }}
            separator=","
          />
        )}
      />
    </div>
  );
}
